import { createWebHistory, createRouter } from 'vue-router';
import loginRouter from './modules/login';
import Cookies from 'js-cookie';

// Vite 支持使用特殊的 import.meta.glob 函数从文件系统导入多个模块
// https://vitejs.cn/vite3-cn/guide/features.html#glob-import
const modules: Record<string, any> = import.meta.glob(['./modules/**/*.ts', '!./modules/**/login.ts'], {
  eager: true // 直接引入
});

/** 原始静态路由（未做任何处理） */
const routes: any[] = [];
Object.keys(modules).forEach((key) => {
  routes.push(modules[key].default);
});

const router = createRouter({
  history: createWebHistory(),
  routes: routes.concat(loginRouter)
});

router.beforeEach((to, from, next) => {
  const whiteList = ['/login'];

  const token = Cookies.get('token');
  const userInfo = Cookies.get('userInfo');
  // 判断路由是否存在，不存在返回404页面

  if (userInfo && token) {
    // 判断当前用户的权限，没有权限返回403页面

    // 用户有权限
    next();
  } else {
    if (whiteList.includes(to.path)) {
      next();
    } else {
      Cookies.remove('token');
      Cookies.remove('userInfo');
      next({ path: '/login' });
    }
  }
  // next()
});

export default router;

export { routes };
